import { Directive, ViewContainerRef, Component, ElementRef, AfterViewInit, ChangeDetectorRef, ViewChild, Input, OnInit, HostListener, ComponentFactoryResolver } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StudentService, AlertService } from '../_services';
import { first } from 'rxjs/operators';
import { Globals } from '../_helpers';
import { OpentokService } from '../_services/opentok.service';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import config from '../../config';
import { SubscriberComponent } from '../subscriber/subscriber.component';
import * as firebase from 'firebase'
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material';
import { DatePipe } from '@angular/common';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export const snapshotToArray = (snapshot: any) => {
  const returnArr = [];

  snapshot.forEach((childSnapshot: any) => {
      const item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
  });

  return returnArr;
};
@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {

  @ViewChild('chatcontent') chatcontent: ElementRef;
  scrolltop: number = null;

  chatForm: FormGroup;
  nickname = '';
  roomname = '';
  message = '';
  users = [];
  chats = [];
  matcher = new MyErrorStateMatcher();

  constructor(private router: Router,
              private route: ActivatedRoute,
              private formBuilder: FormBuilder,
              public datepipe: DatePipe) {
                this.nickname = localStorage.getItem('nickname');
                this.roomname = 'practicalchat/'
                firebase.database().ref('practicalchat/himanshu').on('value', resp => {
                  this.chats=[]
                  this.chats = snapshotToArray(resp);
                  console.log(this.chats)
                  setTimeout(() => this.scrolltop = this.chatcontent.nativeElement.scrollHeight, 500);
                });
              }

  ngOnInit(): void {
    this.chatForm = this.formBuilder.group({
      'msg' : [null]
    });
  }
  onFormSubmit(form: any) {
    const chat = form;
    const newMessage = firebase.database().ref('practicalchat/himanshu').push();
    chat.rcv = 'rcv'
    chat.sender = 'sender';
    newMessage.set(chat);
    this.chatForm = this.formBuilder.group({
      'msg' : [null]
    });
  }
}
